(() => {
  const initEmailModal = () => {
    const emailModal = document.querySelector('#email-modal');

    if (!emailModal) return;

    const modalCloseEl = emailModal.querySelectorAll('[data-micromodal-close-custom]');
    const modalContent = emailModal.querySelector('.email-modal__content');
    const modalImage = emailModal.querySelector('.email-modal__image');
    const mm = gsap.matchMedia();
    const breakpoint = 768;
    const showModalTl = gsap.timeline({
      paused: true,
    });

    mm.add({
      isDesktop: `(min-width: ${breakpoint}px)`,
      isMobile: `(max-width: ${breakpoint - 1}px)`,
    }, (context) => {
      const { isDesktop } = context.conditions;

      if (isDesktop) {
        showModalTl
          .fromTo(emailModal, {
            display: 'none',
          }, {
            display: 'block',
            duration: 0.01,
          })
          .fromTo(emailModal, {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 0.5,
          })
          .fromTo(modalImage, {
            display: 'none',
          }, {
            display: 'block',
            duration: 0.01,
          }, '<')
          .fromTo(modalContent, {
            transform: 'translateX(-50%)',
          }, {
            transform: 'translateX(0)',
            duration: 0.5,
            delay: 0.125,
          })
          .fromTo(modalImage, {
            transform: 'translateX(50%)',
            opacity: '0',
          }, {
            transform: 'translateX(0)',
            opacity: 1,
            duration: 0.5,
          }, '<');
      } else {
        showModalTl
          .fromTo(emailModal, {
            display: 'none',
          }, {
            display: 'block',
            duration: 0.01,
          })
          .fromTo(emailModal, {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 0.5,
          });
      }
    });

    const closeModalTl = gsap.timeline({
      paused: true,
    })
      .to(emailModal, {
        opacity: 0,
        duration: 0.5,
      })
      .to(emailModal, {
        display: 'none',
        duration: 0.01,
        delay: 0.5,
      });

    const closeModal = (event) => {
      event.stopPropagation(event);
      if (event.target.getAttribute('data-micromodal-close-custom') === null) return;
      window.MicroModal.close('email-modal');
      closeModalTl.play();
      localStorage.setItem('emailModalDismissed', 'true');
    };

    const showModal = () => {
      window.MicroModal.show('email-modal');
      showModalTl.play();
    };

    const checkLocalStorage = () => {
      const value = localStorage.getItem('emailModalDismissed');
      if (value === null || value.length === 0) {
        return false;
      }
      return true;
    };

    if (checkLocalStorage()) return;

    window.MicroModal.init({
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      disableScroll: true,
      disableFocus: true, // NF hasn't loaded yet
      // onShow: () => emailModal.querySelector('form input').focus(),
    });

    setTimeout(showModal, 3000);
    modalCloseEl.forEach((el) => el.addEventListener('click', closeModal));

    function setupFloatingLabel() {
      let emailInput;
      let emailLabel;

      checkElementExists('form input', emailModal)
        .then((element) => {
          emailInput = element;
          emailLabel = emailModal.querySelector('.nf-field-label');
          const nfEmailContainer = emailModal.querySelector('.email-container');
          nfEmailContainer.classList.remove('label-hidden');
          prepInputAndAddListeners();
        })
        .catch((error) => error);
      // .catch((error) => {
      //   console.error('Error:', error.message);
      // });

      function prepInputAndAddListeners() {
        emailInput.setAttribute('placeholder', '');

        const floatLabel = () => {
          if (emailInput.value === '') {
            emailLabel.classList.remove('above-input');
          }
        };
        const moveLabelAbove = () => emailLabel.classList.add('above-input');

        emailInput.addEventListener('focusin', moveLabelAbove);
        emailInput.addEventListener('focusout', floatLabel);
        emailInput.addEventListener('change', floatLabel);
      }
    }
    setupFloatingLabel();

    function checkElementExists(selector, parent, maxAttempts = 3, delay = 25) {
      return new Promise((resolve, reject) => {
        let attempts = 0;
        const parentEl = parent || document;

        function check() {
          attempts += 1;

          const element = parentEl.querySelector(selector);

          if (element) {
            resolve(element);
          } else if (attempts < maxAttempts) {
            setTimeout(check, delay);
          } else {
            reject(new Error(`Element '${selector}' not found after ${maxAttempts} attempts.`));
          }
        }

        check();
      });
    }
  };

  if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initEmailModal();
  } else {
    document.addEventListener('DOMContentLoaded', initEmailModal);
  }
})();
